import {
	AdminImportCourse,
	AdminImportStudent,
	AdminImportStudentIdentification,
	AdminImportTeacher,
} from "../rosterImportApiSlice";

export type MergeItem = {
	student: AdminImportStudent;
	match: AdminImportStudentIdentification;
};

const joinParts = (parts: Array<string | null | undefined>) => parts.filter(Boolean).join(" • ");

export const formatStudentInfo = (s: AdminImportStudent, includeName = true) => {
	const meta = joinParts([
		`Student ID: ${s.studentId}`,
		`DOB: ${s.dateOfBirth ?? "Not provided"}`,
		s.gradeLevel != null ? `Grade: ${s.gradeLevel}` : null,
		s.username != null ? `Username: ${s.username}` : null,
	]);

	return includeName ? `${s.lName}, ${s.fName} • ${meta}` : meta;
};

export const formatTeacherInfo = (t: AdminImportTeacher, includeName = true) => {
	const meta = joinParts([
		t.email ? `Email: ${t.email}` : null,
		t.phoneNumber ? `Phone: ${t.phoneNumber}` : null,
	]);

	return includeName ? `${t.lName}, ${t.fName} • ${meta}` : meta;
};

export const formatCourseInfo = (c: AdminImportCourse, includeName = true) => {
	const meta = joinParts([c.grade != null ? `Grade: ${c.grade}` : null]);

	return includeName ? `${c.name}${meta ? ` • ${meta}` : ""}` : meta;
};

export const formatMatchIdentification = (
	m: AdminImportStudentIdentification,
	includeName = true
) => {
	const meta = joinParts([
		`Student ID: ${m.studentId}`,
		`DOB: ${m.dateOfBirth ?? "Not provided"}`,
		m.username != "" ? `Username: ${m.username}` : null,
	]);
	return includeName ? `${m.lName}, ${m.fName} • ${meta}` : meta;
};
